import React from 'react';
import Page from '../../../layout/Page';
import CodeLiability from './CodeLiability';
import SingleUseCodes from './SingleUseCodes';
import { userRoles } from '../../../RoleProtected';
import BundleCodes from './BundleCodes';

const CodesReport = ({ children, ...props }) => {

    return (
        <Page
            title='Codes'
            tabs
        >
            <CodeLiability  tab='Code Liability' roles={userRoles.viewAuditReports} />
            <SingleUseCodes tab='Single Use Codes' roles={userRoles.viewAuditReports}/>
            <BundleCodes tab='Bundle Codes' roles={userRoles.viewAuditReports} />
        </Page >
    );
}

export default CodesReport;
